import CodeIcon from "@mui/icons-material/Code";
import { black, white } from "designSystem/styles/color";
import { Box, Grid, Text, ToggleButton } from "designSystem/index";
import { STANDARD_BORDER_STYLE } from "designSystem/styles/style-functions";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent, ReactElement, useState } from "react";
import { useStore } from "./hooks";

export interface ComponentProps {
	code: string;
	func: () => ReactElement;
	name: string;
	notes?: string;
	className?: string;
}

/**
 * Component to render an instance of a design system component (i.e. primary button)
 */
const Component: FunctionComponent<ComponentProps> = observer((props) => {
	const { className, code, func, name, notes } = props;
	const [open, setOpen] = useState(false);
	const { background } = useStore();
	const formattedCode = code.replace(/\t/g, "\u00A0\u00A0\u00A0\u00A0")
		.replace(/ /g, "\u00A0");

	return (
		<Grid
			container
			direction="column"
			spacing={3}
		>
			<Grid item>
				<Text text={name} variant="h3" />
			</Grid>
			<Grid item>
				<Box
					bgcolor={background ? "lightyellow" : null}
					border={STANDARD_BORDER_STYLE}
					borderRadius="3px"
					className={className}
					overflow="auto"
					p={2}
					textAlign="center"
					width={className ? null : 800}
				>
					{func()}
				</Box>
			</Grid>
			{notes && (
				<Grid item>
					<Text size={13} text={notes} />
				</Grid>
			)}
			<Grid item>
				<ToggleButton
					onClick={() => setOpen(!open)}
					selected={open}
					tooltipProps={{ res: "ShowCode" }}
					value="code"
				>
					<CodeIcon />
				</ToggleButton>
			</Grid>
			{open && (
				<Grid item>
					<Box
						bgcolor={black[100]}
						borderRadius="3px"
						color={white[50]}
						component="code"
						display="inline-block"
						p={2}
					>
						<Text
							size={13}
							text={formattedCode}
							variant="inherit"
						/>
					</Box>
				</Grid>
			)}
		</Grid>
	);
});

export default Component;